import { Dictionary } from "flow/api/types";

export function generateCleanSearchParams(obj: Dictionary) {
    if (!obj) {
        return "";
    }

    const searchParams = Object.entries(obj).reduce((urlSearchParams: URLSearchParams, [key, value]) => {
        if (Array.isArray(value)) {
            // Add each value in the array as a separate parameter
            value.forEach((v: any) => urlSearchParams.append(key, v));
        } else if (value !== null && value !== undefined) {
            // Only add the parameter if it is not null or undefined
            urlSearchParams.append(key, value);
        }
        return urlSearchParams;
    }, new URLSearchParams());

    const parameterQueryStr = searchParams.toString();
    return parameterQueryStr === "" ? "" : "?" + parameterQueryStr;
}
